/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

import Vue from 'vue'
import Vuex from 'vuex'
import modules from './register'

Vue.use(Vuex)

const
  state = {}
const getters = {}
const actions = {}
const mutations = {}

const options = {
  modules,
  state,
  getters,
  actions,
  mutations
}

export default new Vuex.Store(options)
